module.exports = __webpack_public_path__ + "static/cup.f25021d6.png";